import { selectFeatureFlags } from '@ticketmaster/tm1pos-web-shared/feature-flags';
import { useDispatch, useSelector } from 'react-redux';
import { checkout as legacyCheckout } from '../components/form/actions';
import { selectIsEmvPayment } from '../selectors';
import { useLegacyCartId } from './use-legacy-cart-id';
import { useLegacyCheckoutForm } from './use-legacy-checkout-form';
import { useModernCheckout } from './use-modern-checkout';
import type { FeatureFlags } from '@ticketmaster/tm1pos-web-shared/feature-flags/feature-flags-slice';

export function isLegacyCheckout(
  isArchtics: boolean,
  paymentMethod: string,
  isEmvPayment: boolean,
  featureFlags: FeatureFlags,
) {
  if (!isArchtics) {
    return true;
  }
  if (paymentMethod === 'Card' && !isEmvPayment) {
    return true;
  }
  if (featureFlags.monitorPurchase) {
    return true;
  }
  return !featureFlags.modernCheckoutArchtics;
}

export const useCheckoutRouter = () => {
  const featureFlags = useSelector(selectFeatureFlags);
  const dispatch = useDispatch();
  const { checkout: modernCheckout } = useModernCheckout();
  const cartId = useLegacyCartId(); // TODO replace by useSelector when modern reserve is released (or useContext)
  const form = useLegacyCheckoutForm(); // TODO replace by useContext when/during redux-form migration
  const isEmvPayment = useSelector(selectIsEmvPayment);

  const isArchtics = () => cartId?.system === 'ARX';

  const isModernCheckout = () => {
    if (!featureFlags.modernCheckoutArchtics && !featureFlags.monitorPurchase) {
      return false;
    }
    if (!isArchtics()) {
      return false;
    }
    return form.paymentMethod === 'Other' || isEmvPayment;
  };

  const checkout = async () => {
    if (isLegacyCheckout(isArchtics(), form.paymentMethod, isEmvPayment, featureFlags)) {
      dispatch(legacyCheckout());
    }

    if (isModernCheckout()) {
      await modernCheckout();
    }
  };

  return { checkout };
};
